import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: white;
  padding: 1rem 2rem;
  min-height: calc(100vh - 64px);
`;

export const ModelSelectorContainer = styled.div`
  background-color: white;
  border: 1px solid black;
  border-radius: 3px;
  padding: 1rem;
`;

export const ModelComparisonsContainer = styled.div``;
